import { addDays, addMonths, addWeeks, addYears, endOfMonth, endOfWeek, endOfYear, format, startOfMonth, startOfWeek, startOfYear } from 'date-fns';
import type { CalendarView } from '@/pages/Opportunities/types';

export const businessTimezone = 'Europe/Madrid';
export const dateKey = (date: Date): string => format(date, 'yyyy-MM-dd');
export const localDay = (instant: string, timezone = businessTimezone): string => new Intl.DateTimeFormat('en-CA', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(instant));
export const localTime = (instant: string, timezone = businessTimezone): string => new Intl.DateTimeFormat('es-ES', { timeZone: timezone, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date(instant));
export const deadlineLabel = (instant: string | null, language: string): string => instant === null ? '—' : new Intl.DateTimeFormat(language, { dateStyle: 'short', timeStyle: 'short', timeZone: businessTimezone }).format(new Date(instant));
export const moneyLabel = (amount: string | null, currency: string, language: string): string => {
    if(amount === null){
        return '—';
    }
    const [integer, fraction = ''] = amount.split('.');
    const digits = Math.max(2, fraction.replace(/0+$/, '').length);
    const formatter = new Intl.NumberFormat(language, { style: 'currency', currency, minimumFractionDigits: digits, maximumFractionDigits: digits });
    const whole = BigInt(integer);
    const parts = formatter.formatToParts(integer.startsWith('-') && whole === 0n ? -0 : whole);
    return parts.map(part => part.type === 'fraction' ? fraction.padEnd(digits, '0').slice(0, digits) : part.value).join('');
};
export const period = (anchor: Date, view: CalendarView): { from: Date; to: Date } => {
    switch(view){
        case 'day': return { from: anchor, to: anchor };
        case 'week': return { from: startOfWeek(anchor, { weekStartsOn: 1 }), to: endOfWeek(anchor, { weekStartsOn: 1 }) };
        case 'year': return { from: startOfYear(anchor), to: endOfYear(anchor) };
        case 'month': return { from: startOfWeek(startOfMonth(anchor), { weekStartsOn: 1 }), to: endOfWeek(endOfMonth(anchor), { weekStartsOn: 1 }) };
    }
};
export const shiftPeriod = (anchor: Date, view: CalendarView, direction: number): Date => {
    switch(view){
        case 'day': return addDays(anchor, direction);
        case 'week': return addWeeks(anchor, direction);
        case 'month': return addMonths(anchor, direction);
        case 'year': return addYears(anchor, direction);
    }
};
